import { Component } from 'react'
import { Card, Grid, Checkbox, Dropdown } from 'semantic-ui-react'
import api from '../../apis/api'
import UserContext from '../../contexts/UserContext';
import CalendarContext from '../../contexts/CalendarContext'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list';
import CalendarModal from './CalendarModal';
import { ErrorToast } from '../Toasters';


export default class Calendar extends Component {
    static contextType = UserContext

    state = {
        events: [],
        dates: "",
        access:true,
        change:true,
        tca_rm:true,
        group: "All",
        event:{
            _instance: {
                range: {
                    start: "",
                    end: ""
                }
            },
            title:"",
            color:"",
            extendedProps:{number:null, sites:[], notes:'',reason:'',impact:''}
        }
    }
    
    getTickets = (dates) => {
        this._isUpdated = true
        let types = []
        if(this.state.access){
            types.push('access')
        }
        if(this.state.change){
            types.push('change')
        }
        if(this.state.tca_rm){
            types.push('tca_rm')
        }

        api.post('/requests/tickets', {start: new Date(dates.startStr).getTime() / 1000, end: new Date(dates.endStr).getTime() / 1000, type: types}).then(r => {
            let events = r.data.map(e => this.eventParse(e))
            // filter events by group
            if(this.state.group !== 'All'){
                // get sites for group
                let sites = this.context.userInfo.ticket_sites.filter(i => i.owner === this.state.group).map(s => s.site)
                // filter events
                events = events.filter(e => {
                    let bool = false
                    e.sites.forEach(s => {
                        if(sites.includes(s)){
                            bool = true
                        }
                    })
                    return bool
                })
            }

            this.setState({events: events})
        }).catch(err => ErrorToast(err))
    }

    eventParse = (ticket) => {
        let title = ""
        let color = ""
        let start = ""
        if (ticket.type === "access"){
            title = `${ticket.number} - Access Request - ${ticket.siteLabel} - ${ticket.email}`
            color = "#ffa500"
            // mark as 1 day so it doesent take up more space
            start = ticket.endDate
        }
        if (ticket.type === "change"){
            title = `${ticket.number} - Change Request - ${ticket.siteLabel} - ${ticket.subject}`
            color = "#008000"
            start = ticket.startDate
        }
        if (ticket.type === "tca_rm"){
            title = `${ticket.number} - TCA/RM - ${ticket.siteLabel} - ${ticket.email}`
            color = "#2185d0"
            start = ticket.startDate
        }

        return {
            "title": title,
            "start": new Date(start * 1000),
            "end": new Date(ticket.endDate * 1000),
            "color": color,
            "sites": ticket.sites,
            "number": ticket.number,
            "notes": ticket.notes,
            "reason": ticket.reason,
            "impact": ticket.impact,
            "type": ticket.type
        }
    }

    toggleChecked = (toggle) => {
        this._isUpdated = false
        this.setState({[toggle]: !this.state[toggle]})
    }
    
    toggleGroup = (group) => {
        this._isUpdated = false
        this.setState({group: group})
    }

    toggleModal = () => {
        this.setState({modal: !this.state.modal})
    }

    handleEventClick = ({event, el}) => {
        this.setState({
            modal: true,
            event: event,
        })
    }

    componentDidUpdate(){
        if(this._isUpdated === false){
            this.getTickets(this.state.dates)
        }
    }

    
    render() {
        const groups = [...new Set(this.context.userInfo.ticket_sites.map(s => (s.owner)))]
        groups.sort()
        groups.unshift('All')
        return (
            <CalendarContext.Provider value={this.state}>
                <Grid centered>
                    <Grid.Column width={12}>
                        <Card fluid className='calendar-body'>
                            <Card.Content>
                                <Card.Meta className='meta-calendar-checkboxes'>
                                    <div>
                                        <Checkbox label={<label className='calendar-checkbox' >Access</label>} checked={this.state.access} onChange={() => this.toggleChecked('access')}/>
                                        <Checkbox label={<label className='calendar-checkbox' >Change</label>} checked={this.state.change} onChange={() => this.toggleChecked('change')}/>
                                        <Checkbox label={<label className='calendar-checkbox' >TCA/RM</label>} checked={this.state.tca_rm} onChange={() => this.toggleChecked('tca_rm')}/>
                                    </div>
                                    <div>
                                        <Dropdown selection search options={groups.map(i => ({key: i, value: i ,text: i})).sort((a, b) => a.text.localeCompare(b.text))} value={this.state.group} onChange={(e,d) => this.toggleGroup(d.value)} />
                                    </div>
                                </Card.Meta>
                                <FullCalendar
                                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin ]}
                                    initialView="listMonth"
                                    headerToolbar={{
                                        left: 'prev,next today',
                                        center: 'title',
                                        right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
                                    }}
                                    selectable={true}
                                    dayMaxEvents={true}
                                    initialEvents={this.state.events}
                                    events={this.state.events}
                                    eventClick={this.handleEventClick}
                                    datesSet={(date) => {
                                        this.setState({dates: date})
                                        this.getTickets(date)}
                                    }
                                />
                                <CalendarModal modal={this.state.modal} event={this.state.event} toggleModal={this.toggleModal} />
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                </Grid>
                </CalendarContext.Provider>
        )
    }
}
